<ng-template #categoryTmpl let-categories="categories" let-depth="depth">
	<div class="category-navigation depth-{{ depth }}" *ngFor="let category of categories">
		<a
			class="category"
			[ngClass]="{
				'has-children': category.children?.length,
				'is-expanded': category.isExpanded,
				'is-hidden': category | isHiddenCategory: allCategories
			}"
			[routerLink]="['/category', category.id, category.slug]"
			routerLinkActive="active"
			[routerLinkActiveOptions]="{ exact: false }"
			#rla="routerLinkActive"
		>
			<span class="text">{{ category?.locale.name | getText }}</span>
			<span class="badge" i18n>Hidden</span>
			<g-icon
				*ngIf="category.children?.length"
				[icon]="icons[rla.isActive || category.isExpanded ? 'faCaretDown' : 'faCaretRight']"
				[ngClass]="{ active: rla.isActive || category.isExpanded }"
			>
			</g-icon>
		</a>
		<div *ngIf="category.isExpanded && category.children?.length">
			<ng-container
				*ngTemplateOutlet="categoryTmpl; context: { categories: category.children, depth: depth + 1 }"
			>
			</ng-container>
		</div>
	</div>
</ng-template>
<nav data-cy="categoryNav" class="category-container" *ngIf="categories">
	<div class="category-navigation depth-0">
		<a
			class="category"
			[ngClass]="{
				'has-children': false,
				'is-expanded': false,
				'is-hidden': false
			}"
			[routerLink]="['/products']"
			routerLinkActive="active"
			[routerLinkActiveOptions]="{ exact: true }"
			#rla="routerLinkActive"
		>
			<span class="text" i18n>All Products</span>
		</a>
	</div>
	<ng-container
		*ngTemplateOutlet="categoryTmpl; context: { categories: categories, depth: 0 }"
	></ng-container>
</nav>
